import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { formatMoney } from '../streamingFormat';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole screen; each part uses its own slice of it */
import styles from '../Streaming.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface MoneyAmountProps {
  value: number | null;
  /** ISO 4217, or null when the source did not say. */
  currency: string | null;
  className?: string;
}

/**
 * One amount with its currency code next to it ("412.86 USD" style, design e1). An amount with no
 * code shows no code: the block says that the source did not give the currency.
 */
const MoneyAmountComponent: React.FC<MoneyAmountProps> = ({ value, currency, className }) => {
  const intl = useIntl();
  return (
    <span className={styles.amount} data-currency={currency ?? 'none'}>
      <span className={className}>{formatMoney(intl, value, currency)}</span>
      {currency !== null ? <span className={styles.currency}>{currency}</span> : null}
    </span>
  );
};

export const MoneyAmount = TypedMemo(MoneyAmountComponent);
